// extracted by mini-css-extract-plugin
export var avatarContainer = "_e2-0";
export var gray = "_e2-f";
export var green = "_e2-c";
export var icon = "_e2-9";
export var image = "_e2-1";
export var lg = "_e2-6";
export var md = "_e2-5";
export var presenceDot = "_e2-b";
export var red = "_e2-d";
export var sm = "_e2-4";
export var status = "_e2-a";
export var xl = "_e2-7";
export var xs = "_e2-3";
export var xxl = "_e2-8";
export var xxs = "_e2-2";
export var yellow = "_e2-e";